import React from 'react';
import styled from 'styled-components';
import { useForm } from '@formcarry/react';
import SEO from '../seo';

const ContactContainer = styled.div`
  text-align: left;
`;

const ContactIntro = styled.div`
  margin: 2rem auto;
`;
const ContactForm = styled.form`
  margin: 3rem auto;
`;

const StyledInput = styled.input`
  width: 100%;
  background-color: var(--color-secondary);
  font-weight: 500;
  padding: 0.5rem;
  margin: 0.2rem auto 1.6rem auto;
  border-bottom: solid var(--color-text) 1.5px;
  &:focus {
    border-bottom: solid var(--color-primary) 2.5px;
  }
`;
const StyledTextArea = styled.textarea`
  width: 100%;
  height: 110px;
  background-color: var(--color-secondary);
  font-weight: 500;
  padding: 0.5rem;
  margin: 0.2rem auto 1.6rem auto;
  border-bottom: solid var(--color-text) 1.5px;
  &:focus {
    border-bottom: solid var(--color-primary) 2.5px;
  }
`;
const StyledButton = styled.button`
  background: transparent;
  color: var(--color-text);
  font-weight: bold;
  font-size: 1.05rem;
  border: none;
  display: flex;
  margin: 1rem auto;
  padding: 0.8rem 1.8rem;
  border: 1.8px solid var(--color-primary);
  cursor: pointer;
  &:hover {
    /* background-color: var(--color-primary); */
    background-color: var(--color-primary);
  }
  &:focus {
    outline: none;
  }
`;
const SuperScript = styled.sup`
  color: var(--color-primary);
`;
const Contact = () => {
  const { state, submit } = useForm({
    id: 'Ojhy9uMvbF',
  });

  // Success messages
  if (state.submitted) {
    return (
      <p>
        Hey! Thanks for reaching out. I will get back to you as soon as
        possible.
      </p>
    );
  }
  return (
    <ContactContainer>
      <SEO title="Contact" />
      <ContactIntro>
        Got an opportunity to discuss? A project you'd like to discuss? Maybe
        wanna say "Hi!"?
      </ContactIntro>

      <ContactForm onSubmit={submit}>
        <label htmlFor="Name">
          Name <SuperScript>*</SuperScript>
        </label>
        <StyledInput required type="text" label="Name" name="Name" />
        <label htmlFor="Email">
          Email <SuperScript>*</SuperScript>
        </label>
        <StyledInput required type="Email" label="Email" name="Email" />
        <label htmlFor="Message">
          Message <SuperScript>*</SuperScript>
        </label>
        <StyledTextArea required type="text" label="Message" name="Message" />

        <StyledButton type="submit">
          {state.submitting ? <p>Sending.. </p> : <p>Send</p>}
        </StyledButton>
      </ContactForm>
    </ContactContainer>
  );
};

export default Contact;
